<template>
  <div class="ed-grid m-grid-2 s-center">
    <!--  -->
    <section class="ed-grid s-grid-2">
      <div class="card">
        <h3 class="s-left">Incita a la creatividad</h3>
        <p class="s-left">Se generan varios caminos para lograr el mismo objetivo</p>
      </div>
      <div class="card s-right">
        <img
          src="../../img/beneficios/creatividad-blanco.svg"
          alt="cretividad"
        />
      </div>
    </section>
    <!--  -->
    <section class="ed-grid s-grid-2">
      <div class="card">
        <h3 class="s-left">Aprendes de los errores</h3>
        <p class="s-left">Se encuentran nuevas formas de solucionar problemas</p>
      </div>
      <div class="card s-right">
        <img src="../../img/beneficios/error-blanco.svg" alt="error" />
      </div>
    </section>
    <!--  -->
    <section class="ed-grid s-grid-2">
      <div class="card">
        <h3 class="s-left">Fortalece lo que ya sabes</h3>
        <p class="s-left">Se refuerzan los conocimientos que ya tienenes</p>
      </div>
      <div class="card s-right">
        <img
          src="../../img/beneficios/aprendizaje-blanco.svg"
          alt="aprendizaje"
        />
      </div>
    </section>
    <!--  -->
    <section class="ed-grid s-grid-2">
      <div class="card">
        <h3 class="s-left">Aprendes por tu cuenta</h3>
        <p class="s-left">Comienzas a investigar cómo resolver las cosas</p>
      </div>
      <div class="card s-right">
        <img
          src="../../img/beneficios/autodidacta-blanco.svg"
          alt="autodidacta"
        />
      </div>
    </section>
  </div>
</template>
<style scoped>
@media (max-width: 1024px) {
  .beneficios {
    width: 70%;
    margin-left: 15%;
  }
}
@media (max-width: 768px) {
  .beneficios {
    width: 50%;
    margin-left: 5%;
  }
}
section {
  background: #017959;
  display: flex;
  align-items: center;
  padding: 3%;
  border-radius: 10px;
  box-shadow: 2px 4px 4px rgba(0, 0, 0, 0.25);
  width: 100%;
}
h3 {
  color: #fff;
}
p {
  color: #fff;
}
img {
  width: 70%;
  height: 70%;
  color: #fff;
}
</style>